/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { DependencyList } from 'react';
import { useRegisterCommandsWithRegistry } from '@jira/compal__command-palette/src/controllers/use-register-commands/index.tsx';
import type { Command } from '@jira/compal__command-palette/src/common/types/commands/index.tsx';
import type { COMMAND_PALETTE_REGISTRY_ID } from '../../common/constants/registry/index.tsx';

export const useRegisterCommands: (
	registrationId:
		| 'ADD_CHILD_ISSUE'
		| 'ADMIN_NAVIGATION'
		| 'ASK_ROVO'
		| 'CHECK_NOTIFICATIONS'
		| 'COPY_URL'
		| 'DESCRIPTION'
		| 'ISSUE_ACTIONS'
		| 'ISSUE_FIELD_ASSIGN'
		| 'ISSUE_HEADER_ACTIONS'
		| 'ISSUE_SUB_HEADER_ACTIONS'
		| 'LOG_WORK'
		| 'NAVIGATION_COMMANDS'
		| 'PARENT'
		| 'PROJECT_NAVIGATION'
		| 'QUICK_ADD'
		| 'QUICK_SEARCH'
		| 'SHORTCUTS'
		| 'STATUS'
		| 'STORY_POINTS'
		| 'TEST'
		| 'THEME_MODE'
		| 'FORGE',
	commands: Command[],
	dependencies?: DependencyList,
) => void = useRegisterCommandsWithRegistry<COMMAND_PALETTE_REGISTRY_ID>;
